module.exports = __webpack_public_path__ + "img/facebook.63b3bd08.svg";